import React, { Component } from "react";
import auth from "../../components/auth";
import BackDrop from "../../components/Backdrop/Backdrop";
import CanvasJSReact from "../../components/canvasjs-2.3.1/canvasjs.react";
import { url } from "../../components/url";
import "./Graph.css";
// var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
class Graph extends Component {
  state = {
    title: "Individual Registration",
    table: "indv",
    tax_office: "Head Office",
    year: "2020",
    taxOffList: [],
    isShowLoader: true,
    result: []
  };

  componentDidMount() {
    this.getTaxOffices();
    this.renderGraph();
  }

  getTaxOffices = () => {
    let formData = JSON.stringify({
      name: "getTaxOffices",
      param: {}
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        // console.log(res);
        if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            this.logout();
          }
        } else {
          this.setState({ taxOffList: res });
        }
      })
      .catch(error => {
        if (error === "TypeError: Network request failed") {
          alert(
            "Something went wrong Kindly check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      });
  };

  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  setStation = val => {
    this.setState({ tax_office: val.target.value }, () => {
      this.renderGraph();
    });
  };

  setYear = val => {
    this.setState({ year: val.target.value }, () => {
      this.renderGraph();
    });
  };

  displayIndvHandler = () => {
    this.setState({ title: "Individual Registration", table: "indv" }, () => {
      this.chooseTable();
    });
  };
  displayNonIndvHandler = () => {
    this.setState(
      { title: "Non Individual Registration", table: "non_indv" },
      () => {
        this.chooseTable();
      }
    );
  };

  renderGraph = () => {
    this.setState({ isShowLoader: true });
    let formData = JSON.stringify({
      name: "plotGraph",
      param: {
        station: this.state.tax_office,
        year: this.state.year
      }
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        // console.log(data);
        if (data.hasOwnProperty("error")) {
          alert(data.error.message);
          this.logout();
        } else this.setState({ result: data, isShowLoader: false });
      })
      .catch(error => {
        this.setState({ isShowLoader: false });

        if (error === "TypeError: Network request failed") {
          alert(
            "Something went wrong Kindly check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      })
      .then(e => this.chooseTable());
  };

  selectTable;

  chooseTable = () => {
    if (this.state.table === "indv") {
      this.selectTable = this.state.result.indv;
    } else {
      this.selectTable = this.state.result.non_indv;
    }
    if (this.selectTable !== undefined) {
      this.selectTable = this.selectTable.map(ele => {
        delete ele.x;
        return ele;
      });

      this.getValues();
    }
  };

  getValues = () => {
    this.setState({
      data: [
        { label: "jan", y: Number(this.check(this.get("jan")[0]).y) },
        { label: "feb", y: Number(this.check(this.get("feb")[0]).y) },
        { label: "march", y: Number(this.check(this.get("march")[0]).y) },
        { label: "april", y: Number(this.check(this.get("april")[0]).y) },
        { label: "may", y: Number(this.check(this.get("may")[0]).y) },
        { label: "june", y: Number(this.check(this.get("june")[0]).y) },
        { label: "july", y: Number(this.check(this.get("july")[0]).y) },
        { label: "aug", y: Number(this.check(this.get("aug")[0]).y) },
        { label: "sept", y: Number(this.check(this.get("sept")[0]).y) },
        { label: "oct", y: Number(this.check(this.get("oct")[0]).y) },
        { label: "nov", y: Number(this.check(this.get("nov")[0]).y) },
        { label: "dec", y: Number(this.check(this.get("dec")[0]).y) }
      ]
    });
  };

  check = val => {
    if (val !== undefined) {
      return val;
    } else {
      return { y: "0" };
    }
  };
  get = month => {
    return this.selectTable.filter(val => val.label === month);
  };

  render() {
    const taxOffice = this.state.taxOffList.map((office, i) => {
      return (
        <option key={i} value={office.station_code}>
          {office.station_code}
        </option>
      );
    });

    const options = {
      animationEnabled: true,
      exportEnabled: true,
      title: {
        text: this.state.title,
        fontSize: 20
      },
      axisY: {
        title: "Total Number"
      },
      data: [
        {
          type: "spline",
          xValueFormatString: "MMM ",
          dataPoints: this.state.data
        }
      ]
    };

    let loading = (
      <BackDrop>
        <p>loading...</p>
      </BackDrop>
    );

    return (
      <div>
        {this.state.isShowLoader ? loading : null}
        <div style={styles.pickerStyle}>
          <select style={styles.box} onChange={this.setYear}>
            <option value="2020">2020</option>
            <option value="2019">2019</option>
            <option value="2018">2018</option>
            <option value="2017">2017</option>
          </select>
          <select style={styles.box} onChange={this.setStation}>
            {taxOffice}
          </select>
        </div>
        <CanvasJSChart options={options} onRef={ref => (this.chart = ref)} />
        {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}

        <div className="buttonGroup">
          <button className="individual" onClick={this.displayIndvHandler}>
            <p>Individual</p>
          </button>
          <button
            className="nonIndividual"
            onClick={this.displayNonIndvHandler}
          >
            <p> Non Individual</p>
          </button>
        </div>
      </div>
    );
  }
}
export default Graph;
const styles = {
  pickerStyle: {
    display: "flex",
    paddingTop: 5,
    margin: " 0 15px 0 15px"
  },

  label: {
    paddingTop: 7,
    width: "50%"
  },
  box: {
    height: 50,
    outline: "none",
    width: "50%"
  }
};
